<script lang="ts">
    import { onMount } from 'svelte';
    import Newsletter from '../components/Newsletter.svelte';
    import Shutter from '../components/Shutter.svelte';
    import { storePages, emptyPage, Page } from '../scripts/classes/page';
    import BallsContacts from '../components/BallsAccompagner.svelte';
    import NewsletterRegistration from '../components/NewsletterRegistration.svelte';

    let page: Page = emptyPage;
    const idPage = 3;

    onMount(async () => {
        window.scrollTo(0,0);
        page = $storePages.filter(item => {
            return (item.id == idPage);
        })[0];
	});

</script>
    
<style lang="scss">
    .contacts {
        &__content {
            margin-top: 30px;
        }
        &__shutters {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 0 0 0 0;
        }
        &__shutter {
            width: 100%;
            margin: 0 0 20px 0;
        }
    }

    @include large {
        .contacts {
            &__content {
                margin-top: 50px;
            }
            &__shutters {
                margin: 0 0 90px 0;
            }
            &__shutter {
                margin: 0 0 40px 0;
            }
            &__trefle {
                top: 80px;
                width: 420px;
            }
        }
    }

    @include xlarge {
        .contacts {
            &__trefle {
                top: 70px;
                width: 500px;
            }
        }
    }
</style>

<div class="page">
    <div class="page__contener">
        <div class="page__title">{page.title}</div>
        <div class="page__intro">
            {@html page.text}
        </div>
        <div class="page__trefle contacts__trefle">
            <img class="page__trefle__img" src="../assets/images/illustration_contacts.png" alt="">
        </div>
        <div class="page__content contacts__content">
            <div class="contacts__shutters">
                {#each page.shutters as item, i}
                {#if i % 2 == 0}
                <div class="contacts__shutter">
                    <Shutter inShutter={{shutter: item, radius: true, isContact: true}}/>
                </div>
                {:else}
                <div class="contacts__shutter">
                    <Shutter inShutter={{shutter: item, radius: false, isContact: true}}/>
                </div>
                {/if}
                {/each}
            </div>
        </div>
    </div>
    <BallsContacts />
    <Newsletter />
    <NewsletterRegistration />
</div>
